import * as React from 'react'
import { Stack, Text } from '@sanity/ui'
import { useDocumentPane } from 'sanity/desk'

/** @param {import('sanity').ObjectFieldProps} props */
export default function ActiveAnnouncementBanners(props) {
  const { schemaType } = useDocumentPane()

  if (schemaType?.description) {
    // Show the document's description above the field it exists.
    // If linebreaks are included in the description, it is be split
    // across multiple Text components
    return (
      <Stack space={4}>
        {schemaType.description.split(/\n+/).map((str, index) =>
          str.trim() ? (
            <Text key={str} muted size={index > 0 ? 1 : 2}>
              {str}
            </Text>
          ) : null
        )}
        {props.renderDefault(props)}
      </Stack>
    )
  }

  return props.renderDefault(props)
}
